// pesquisa de satisfacao IndeCX
/* eslint-disable no-undef */
function pesquisa(user, key, action) {
    if (!user || !key || !action) return;

    const existingScript = document.getElementById('script-indecx');

    const initWidget = () => {
        if (typeof window.IndeCX !== 'function') {
            console.warn('IndeCX ainda não disponível');
            return;
        }

        try {
            window.IndeCX({
                key,
                action,
                name: user.nmusuario,
                email: user.email,
                indicators: {
                    CDUSUARIO: user.username,
                    SISTEMA: 'stip'
                },
                onError: (e) => console.error('Erro ao carregar pesquisa: ', e)
            });
        } catch (err) {
            console.error('Erro ao inicializar IndeCX:', err);
        }
    };

    if (existingScript) {
        // Script já carregado?
        if (window.IndeCX) {
            initWidget();
        } else {
            existingScript.addEventListener('load', initWidget);
        }
        return;
    }

    const script = document.createElement('script');
    script.id = 'script-indecx';
    script.src = 'https://indecx-widget.s3.amazonaws.com/widget-production-v3.js';
    script.async = true;

    script.onload = initWidget;

    document.body.appendChild(script);
}

export default pesquisa;
